import {
  type PartnerPickDeviceCreateMutationVariables,
  type PartnerPickDeviceQuery,
  type PartnerPickDeviceUpdateMutationVariables,
} from 'domains/partner-pick-devices/api'
import {
  PartnerPickDeviceAccountTypeEnum,
  type PartnerPickDevicesFormData,
} from 'domains/partner-pick-devices/types/partnerPickDevices.types'

export const mapPartnerPickDeviceFormDataToCreateMutationPayload: (
  formData: PartnerPickDevicesFormData,
  warehouseLocationId: string
) => PartnerPickDeviceCreateMutationVariables = (formData, warehouseLocationId) => ({
  warehouseLocationId,
  deviceType: formData.deviceType,
  firstName: formData.firstName,
  lastName: formData.lastName,
  email: formData.email,
  phone: formData.phone,
  password: formData.password,
  isPartnerPickStoreManager: formData.accountType === PartnerPickDeviceAccountTypeEnum.Manager,
})

export const mapPartnerPickDeviceFormDataToUpdateMutationPayload: (
  formData: PartnerPickDevicesFormData,
  deviceId: string,
  warehouseLocationId: string
) => PartnerPickDeviceUpdateMutationVariables = (formData, deviceId, warehouseLocationId) => ({
  id: deviceId,
  deviceType: formData.deviceType,
  firstName: formData.firstName,
  lastName: formData.lastName,
  email: formData.email,
  phone: formData.phone,
  password: formData.password,
  isPartnerPickStoreManager: formData.accountType
    ? formData.accountType === PartnerPickDeviceAccountTypeEnum.Manager
    : undefined,
  warehouseLocationId,
})

export const mapPartnerPickDeviceQueryResultToFormData: (
  data: PartnerPickDeviceQuery['partnerPickDevice']
) => PartnerPickDevicesFormData = data => ({
  deviceType: data.deviceType,
  firstName: data.firstName,
  lastName: data.lastName,
  email: data.email,
  phone: data.phone,
  accountType: data.isPartnerPickStoreManager
    ? PartnerPickDeviceAccountTypeEnum.Manager
    : PartnerPickDeviceAccountTypeEnum.Shopping,
})
